module.exports = __webpack_public_path__ + "assets/img/A4-2.34f3c0c4.jpg";